import {clone, isNoU} from "utils/DBUtils";
/**
 * Object to expose select functionality from ResourceForm
 */
class ResourceFormProxy {
    _form = null;
    _fieldPath = [];
    _resourcePath = [];

    constructor(form, fieldPath, resourcePath) {
        this._form = form;
        this._fieldPath = fieldPath;
        this._resourcePath = resourcePath;
    }

    get fieldPath() {
        return this._fieldPath;
    }

    get resourcePath() {
        return this._resourcePath;
    }

    // Convenience methods for getting values and resources

    get value() {
        return this.valueForField(this._fieldPath);
    }

    get currentValue() {
        return this.currentValueForField(this._fieldPath);
    }

    get resource() {
        return this.resourceAtPath(this._resourcePath);
    }

    get currentResource() {
        return this.currentResourceAtPath(this._resourcePath);
    }

    get baseResource() {
        return this.resourceAtPath([]);
    }

    get currentBaseResource() {
        return this.currentResourceAtPath([]);
    }

    /**
    * If this current resource has a parent this will return it
    * by going up one index on the field path to find it.  This
    * return the full resource for all platforms in an object
    * where each platform is the key.
    **/
    get parentResource() {
      if ( typeof(this._resourcePath) !== 'undefined' && this._resourcePath.length > 1 ) {
        return this.resourceAtPath( this.parentPath(this._resourcePath) );
      }else {
        console.error("No parent found for path " + this._resourcePath);
        return null;
      }
    }

    get grandParentResource() {
      if (!isNoU(this._resourcePath) && this._resourcePath.length > 2 ) {
        return this.resourceAtPath( this.grandParentPath );
      }else {
        console.error("No grandparent found for path " + this._resourcePath);
        return null;
      }
    }

    get grandParentResource() {
      if (!isNoU(this._resourcePath) && this._resourcePath.length > 3 ) {
        return this.resourceAtPath( this.greatGrandParentPath );
      }else {
        console.error("No great grandparent found for path " + this._resourcePath);
        return null;
      }
    }

    /**
    * Same as parentResource except it returns the value for the current platform
    * ONLY, not the full object with all platforms.
    **/
    get parentCurrentResource() {
      if ( typeof(this._resourcePath) !== 'undefined' && this._resourcePath.length > 1 ) {
        return this.currentResourceAtPath( this.parentPath(this._resourcePath) );
      }else {
        console.error("No parent found for path " + this._resourcePath);
        return null;
      }
    }

    get grandParentCurrentResource() {
      if (!isNoU(this._resourcePath) && this._resourcePath.length > 2 ) {
        return this.currentResourceAtPath( this.grandParentPath() );
      }else {
        return null;
      }
    }

    get greatGrandParentCurrentResource() {
      if (!isNoU(this._resourcePath) && this._resourcePath.length > 3 ) {
        return this.currentResourceAtPath( this.greatGrandParentPath() );
      }else {
        return null;
      }
    }

    parentPath( path ) {
      var parentPath;
      if (!isNoU(path)) {
        parentPath = clone(path.slice());
      }else {
        parentPath = clone(this.resourcePath);
      }
      parentPath.pop();
      return parentPath;
    }

    grandParentPath(path) {
      return this.parentPath(this.parentPath(path));
    }

    greatGrandParentPath(path) {
      return this.parentPath(this.grandParentPath(path));
    }

    // Resource form proxy methods

    valueForField(fieldPath) {
        return this._form.valueForField(fieldPath);
    }

    currentValueForField(fieldPath) {
        return this._form.currentValueForField(fieldPath);
    }

    resourceAtPath(resourcePath) {
        return this._form.resourceAtPath(resourcePath);
    }

    currentResourceAtPath(resourcePath) {
        return this._form.currentResourceAtPath(resourcePath);
    }

    makeSectionFieldsWithWrapper(field, elementPath, elementResourcePath, index, sectionKeyPath) {
        return this._form.makeSectionFieldsWithWrapper(field, elementPath, elementResourcePath, index, sectionKeyPath)
    }

    makeSectionWrapper(SectionWrapperComponent, key, section, sectionIndex, fieldPath, resourcePath, children, sectionGroup, sectionKeyPath) {
        return this._form.makeSectionWrapper(SectionWrapperComponent, key, section, sectionIndex, fieldPath, resourcePath, children, sectionGroup, sectionKeyPath);
    }

    makeSectionFields(section, baseFieldPath, baseResourcePath, sectionIndex, sectionKeyPath) {
        return this._form.makeSectionFields(section, baseFieldPath, baseResourcePath, sectionIndex, sectionKeyPath);
    }

    sectionWrapper() {
        return this._form.props.sectionWrapper;
    }

    makeProxy(fieldPath, resourcePath) {
        return this._form.makeProxy(fieldPath, resourcePath);
    }
}

export default ResourceFormProxy;



// WEBPACK FOOTER //
// ./public/classes/ResourceFormProxy.js